import { render, staticRenderFns } from "./otherInvestigate.vue?vue&type=template&id=bfe88424&scoped=true&"
import script from "./otherInvestigate.vue?vue&type=script&lang=tsx&"
export * from "./otherInvestigate.vue?vue&type=script&lang=tsx&"
import style0 from "./otherInvestigate.vue?vue&type=style&index=0&id=bfe88424&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe88424",
  null
  
)

export default component.exports